export default {
  root: (isXs, minHeight, isSwiperLoaded, width) => ({
    position: 'relative',
    boxSizing: 'border-box',
    ...(width ? { width } : { width: isSwiperLoaded ? '100%' : 292 }),
    height: !isXs && '100%',
    p: 3,
    minHeight,
    ...(isXs
      ? {
          p: 2,
          pb: 4,
          minHeight,
        }
      : {}),
  }),
  header: (isBgImageUse, isXs) => ({
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    alignItems: isBgImageUse ? 'flex-start' : 'center',
    width: '100%',
    ...(isXs
      ? { minHeight: isBgImageUse ? 39 : 28 }
      : { minHeight: isBgImageUse ? 55 : 28 }),
    mb: 2,
  }),
  alignItemsTop: {
    alignItems: 'flex-start',
    minHeight: '55px !important',
  },
  period: (isBgImageUse) => ({
    letterSpacing: '-0.07em',
    lineHeight: isBgImageUse ? '130% !important' : '0.4em !important',
  }),
  description: {
    position: 'relative',
    lineHeight: '1.4em !important',
    letterSpacing: '-0.02em',
    size: 10,
    mt: 2,
  },
  bgImageBlock: {
    borderRadius: 14,
    width: '101%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  bgImage: {
    borderRadius: 9,
    position: 'absolute',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    zIndex: '0',
  },
};
